/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';

import {AdnApiClientService} from '../../common/controller/adn-api-client.service';
import {
  AdminObjectState,
  SignalAdminResourceApiBase,
  SignalAdminResourcePage
} from '../../common/controller/signal-admin-resource-api';

export interface LayoutIncludeModel {
  id: string;
  name?: string;
  reference?: string;
  description?: string;
  renderTemplate?: string;
  labels?: any;
  objectState?: AdminObjectState;
  validationWarnings?: any[];
}

export interface LayoutUsageModel {
  id: string;
  name?: string;
  description?: string;
  layoutType?: string;
  layoutCategory?: string;
  objectState?: AdminObjectState;
  validationWarnings?: any[];
}

@Injectable({providedIn: 'root'})
export class LayoutIncludeApiService extends SignalAdminResourceApiBase<LayoutIncludeModel> {
  constructor(client: AdnApiClientService) {
    super(client, 'layoutincludes');
  }

  getMany(ids: string[]): Observable<SignalAdminResourcePage<LayoutIncludeModel>> {
    return this.client.request({
      method: 'GET',
      url: this.resourceUri('layoutincludes'),
      params: {
        id: ids.join(';'),
        includeHidden: false,
        includeActive: true,
        includeInactive: false,
        orderBy: 'name',
        pageSize: ids.length
      }
    });
  }
}

@Injectable({providedIn: 'root'})
export class LayoutUsageApiService extends SignalAdminResourceApiBase<LayoutUsageModel> {
  constructor(client: AdnApiClientService) {
    super(client, 'layouts');
  }
}
